import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clickMenuBtn } from "../NavBar/NavBarSlice.js";
import "./MenuBar.css";

export const MenuBar = () => {
  const dispatch = useDispatch();
  const checkMenuBar = useSelector((state) => state.navBar.isMenuBtnClicked);
  //Handle Menu NavLink
  function handleNavLink() {
    if (checkMenuBar) {
      dispatch(clickMenuBtn());
    }
  }

  const items = [
    {
      recommendation: ["GET SOME", "RECOMMENDATIONS"],
    },
    {
      filter: ["PICK BY GENRES &", "KEYWORDS"],
    },
    {
      search: ["SEARCH FOR WHAT", "YOU LOVE"],
    },
  ];

  return (
    <div className="MenuBarContainer">
      {items.map((item, index) => (
        <NavLink key={index} className="nav_link" to={`/${Object.keys(item)[0]}`} onClick={handleNavLink}>
          <MenuBarItem
            itemName={Object.keys(item)[0]}
            itemValue={Object.values(item)[0]}
          />
        </NavLink>
      ))}
    </div>
  );
};

export const MenuBarItem = (props) => {
  const { itemName, itemValue } = props;

  const styleMenuItemContainer = {
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    gap: "5px",
    padding: "0 4vw"
  };

  const styleUpperText = {
    color: "#fff"
  };
  const styleLowerText = {
    color: "#fff",
    display: "flex",
    gap: "5px"
  };
  const styleLineIcon = {
    position: "relative",
    top: "50%",
    display: "flex",
    alignItems: "center",
  };

  return (
    <div className={`menu-${itemName}`} style={styleMenuItemContainer}>
      <div className="upperText" style={styleUpperText}>{itemValue[0]}</div>
      <div className="lineIcon" style={styleLineIcon}>
        <svg
          preserveAspectRatio="none"
          viewBox="0 0 450 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
        >
          <path d="M0 0L450 3.93402e-05" stroke="white" strokeWidth={5} />
        </svg>
      </div>
      <div className="lowerText" style={styleLowerText}>
        <span>{itemValue[1]}</span>
        <div className="polygonIcon">
          <svg
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="14px"
            height="14px"
          >
            <path
              d="M25 12.5L6.25 23.3253L6.25 1.67468L25 12.5Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
